import { render } from "./PendingEvaluationReport.vue?vue&type=template&id=15cc3ac2&scoped=true"
import script from "./PendingEvaluationReport.vue?vue&type=script&lang=js"
export * from "./PendingEvaluationReport.vue?vue&type=script&lang=js"

import "./PendingEvaluationReport.vue?vue&type=style&index=0&id=15cc3ac2&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cc3ac2"]])

export default __exports__